var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewAroo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3578 1.29251C16.6895 0.62446 15.6059 0.624689 14.9379 1.29251C14.2694 1.96101 14.2694 3.04431 14.9381 3.71282L21.5138 10.2881L2.47198 10.29C1.52693 10.2902 0.760984 11.0561 0.760984 12.0016C0.761213 12.9466 1.52715 13.7123 2.47221 13.7123L21.5147 13.7105L14.9374 20.2872C14.2691 20.9555 14.2691 22.0392 14.9374 22.7073C15.2717 23.0413 15.7095 23.2085 16.1476 23.2085C16.5855 23.2085 17.0233 23.0413 17.3576 22.7075L26.8558 13.2097C27.1768 12.8889 27.357 12.4538 27.357 11.9998C27.3568 11.5457 27.1765 11.1109 26.8555 10.7894L17.3578 1.29251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAroo);
export default __webpack_public_path__ + "static/media/newAroo.fd2967c71217fe8294e91c83ef390d0a.svg";
export { ForwardRef as ReactComponent };